import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'

import { Invoice } from '../../api/services/invoice/types.ts'
import { convertToShortDate } from '../formatter.ts'
import { getImageDataUrl } from './getImageDataUrl.ts'
import { slownie } from './slownie.ts'

export const printInvoicesToOnePdf = async (
  invoices: Invoice[],
  filename: string
) => {
  const doc = new jsPDF()
  for (let i = 0; i < invoices.length; i++) {
    if (i > 0) doc.addPage()
    await drawInvoiceOnPdf(doc, invoices[i])
  }
  doc.save(filename)
}

export const drawInvoiceOnPdf = async (doc: jsPDF, invoice: Invoice) => {
  const startY = 20
  let startY_1 = startY
  let startY_2 = startY
  // const doc = new jsPDF()
  const pageWidth = doc.internal.pageSize.getWidth() - 15

  const logoDataUrl = await getImageDataUrl('/logo_apz.png')
  doc.addImage(logoDataUrl, 'PNG', 15, 10, 30 * 1.31, 30)

  doc.setFont('Roboto-Regular', 'normal')
  doc.setFontSize(11)
  doc.setTextColor('black')
  doc.text('FAKTURA NUMER', pageWidth, startY, { align: 'right' })
  doc.setFontSize(18)
  doc.text(`${invoice.invoice_number}`, pageWidth, startY + 8, {
    align: 'right'
  })

  doc.setFontSize(12)

  doc.text(
    `Data sprzedaży: ${convertToShortDate(invoice.sales_date)}`,
    pageWidth,
    startY + 20,
    { align: 'right' }
  )
  doc.text(
    `Data wydania: ${convertToShortDate(invoice.created_at)}`,
    pageWidth,
    startY + 25,
    { align: 'right' }
  )

  startY_1 += 40
  startY_2 += 40

  doc.setTextColor('#87B725')
  doc.text('Sprzedawca:', 14, startY_1)
  doc.setTextColor('#000')
  doc.text(invoice.issuing_company_data.name, 14, startY_1 + 5)
  doc.text(
    invoice.issuing_company_data.address1 +
      ' ' +
      invoice.issuing_company_data.building +
      ' ' +
      invoice.issuing_company_data.flat_number,
    14,
    startY_1 + 10
  )
  startY_1 += 15
  if (invoice.issuing_company_data.address2.length > 0) {
    doc.text(invoice.issuing_company_data.address2, 14, startY_1)
    startY_1 += 5
  }

  doc.text(
    invoice.issuing_company_data.postal_code +
      ' ' +
      invoice.issuing_company_data.city,
    14,
    startY_1
  )
  doc.text(`NIP: ${invoice.issuing_company_data.nip}`, 14, startY_1 + 5)

  doc.setTextColor('#87B725')
  doc.text('Nabywca:', 120, startY_2)
  doc.setTextColor('#000')
  doc.text(invoice.recipient_company_data.name, 120, startY_2 + 5)
  doc.text(
    invoice.recipient_company_data.address1 +
      ' ' +
      invoice.recipient_company_data.building +
      ' ' +
      invoice.recipient_company_data.flat_number,
    120,
    startY_2 + 10
  )
  startY_2 += 15
  if (invoice.recipient_company_data.address2.length > 0) {
    doc.text(invoice.recipient_company_data.address2, 120, startY_2)
    startY_2 += 5
  }

  doc.text(
    invoice.recipient_company_data.postal_code +
      ' ' +
      invoice.recipient_company_data.city,
    120,
    startY_2
  )
  doc.text(`NIP: ${invoice.recipient_company_data.nip}`, 120, startY_2 + 5)

  const sumNet = invoice.positions.reduce((sum, item) => {
    const unitNet = (
      Number(item.unit_price) / Number(1 + item.vat_rate / 100)
    ).toFixed(2)
    const totalNet = (Number(unitNet) * item.quantity).toFixed(2)
    return sum + Number(totalNet)
  }, 0)

  const sumVAT = invoice.positions.reduce((sum, item) => {
    const unitNet = (
      Number(item.unit_price) / Number(1 + item.vat_rate / 100)
    ).toFixed(2)
    const totalNet = (Number(unitNet) * item.quantity).toFixed(2)
    const totalVAT = (Number(item.total_price) - Number(totalNet)).toFixed(2)

    return sum + Number(totalVAT)
  }, 0)

  const sumGross = invoice.positions.reduce((sum, item) => {
    return sum + parseFloat(item.total_price)
  }, 0)

  doc.setFont('Roboto-Regular', 'normal')
  // Użycie autoTable do narysowania tabeli z pozycjami faktury
  ;(autoTable as any)(doc, {
    startY: startY + 75,
    tableWidth: 'auto',
    head: [
      [
        'Opis',
        'Ilość',
        'Cena netto',
        'Wartość netto',
        'VAT %',
        'Wartość VAT',
        'Wartość brutto'
      ]
    ],
    body: invoice.positions.map((item) => {
      const unitNet = (
        Number(item.unit_price) / Number(1 + item.vat_rate / 100)
      ).toFixed(2)
      const totalNet = (Number(unitNet) * item.quantity).toFixed(2)
      const totalVAT = (Number(item.total_price) - Number(totalNet)).toFixed(2)

      return [
        item.description,
        item.quantity.toString(),
        unitNet,
        totalNet,
        item.vat_rate,
        totalVAT,
        item.total_price
      ]
    }),
    foot: [
      [
        {
          content: '',
          styles: { fillColor: '#FFF' }
        },
        {
          content: '',
          styles: { fillColor: '#FFF' }
        },
        {
          content: 'RAZEM',
          styles: {
            halign: 'right',
            font: 'Roboto-Regular',
            fontStyle: 'normal'
          }
        },
        {
          content: sumNet.toFixed(2),
          styles: {
            halign: 'right',
            font: 'Roboto-Regular',
            fontStyle: 'normal'
          }
        },
        '',
        {
          content: sumVAT.toFixed(2),
          styles: {
            halign: 'right',
            font: 'Roboto-Regular',
            fontStyle: 'normal'
          }
        },
        {
          content: sumGross.toFixed(2),
          styles: {
            halign: 'right',
            font: 'Roboto-Regular',
            fontStyle: 'normal'
          }
        }
      ]
    ],
    styles: {
      font: 'Roboto-Regular',
      fontStyle: 'normal',
      fontSize: 11
    },
    headStyles: {
      font: 'Roboto-Regular',
      fontStyle: 'normal',
      fillColor: '#87B725'
    },
    columnStyles: {
      1: { halign: 'right' },
      2: { halign: 'right' },
      3: { halign: 'right' },
      4: { halign: 'right' },
      5: { halign: 'right' },
      6: { halign: 'right' }
    },
    didParseCell: function (data: any) {
      if (data.section === 'head') {
        if (data.column.index !== 0) {
          data.cell.styles.halign = 'right'
        }
      }
    }
  })

  const finalY = (doc as any).lastAutoTable.finalY ?? 90
  doc.setFontSize(11)
  doc.text(
    `Wartość netto:    ${Number(sumNet).toFixed(2)} PLN`,
    pageWidth,
    finalY + 5,
    { align: 'right' }
  )
  doc.text(
    `Wartość VAT:    ${Number(sumVAT).toFixed(2)} PLN`,
    pageWidth,
    finalY + 10,
    { align: 'right' }
  )
  doc.text(
    `Wartość brutto:    ${Number(sumGross).toFixed(2)} PLN`,
    pageWidth,
    finalY + 15,
    { align: 'right' }
  )

  doc.text('Do zapłaty:', 14, finalY + 35)
  doc.text(`${Number(sumGross).toFixed(2)} PLN`, 50, finalY + 35)
  doc.text('Słownie:', 14, finalY + 40)
  doc.text(`${slownie(sumGross)} PLN`, 50, finalY + 40)

  doc.setFontSize(16)
  doc.setTextColor('lightBlue')
  doc.text('OPŁACONO', (pageWidth - 15) / 2, finalY + 60)

  // const pdfUrl = doc.output('bloburl')
  // window.open(pdfUrl, '_blank')
}
